import React, { FunctionComponent, useMemo } from 'react';

import { setHtml } from 'Modules/ui';
import { Typography, TypographyProps } from 'Modules/ui3';

import { WithContentSize } from '../types';

/*
    BLOCK: paragraph
    PARAMS: text: string
    EXAMPLE:
    {
        "type" : "paragraph",
        "data" : {
            "text" : "Check out our projects on a <a href=\"https://github.com/codex-team\">GitHub page</a>.",
        }
    }
 */

type ParagraphRenderProps = WithContentSize & {
    text: string;
};

export const ParagraphRenderer: FunctionComponent<ParagraphRenderProps> = ({
    text, size,
}) => {
    const typographyProps = useMemo<TypographyProps<'p'>>(() => ({
        my: {
            desktop: '24px',
            mobile: '16px',
        }[size],
        fontSize: {
            desktop: '20px',
            mobile: '16px',
        }[size],
        lineHeight: {
            desktop: '1.5',
            mobile: '1.4',
        }[size],
    }), [size]);
    return (
        <Typography
            component='p'
            fontWeight='400'
            color='grayscale.shade90'
            {...typographyProps}
            {...setHtml(text)}
        />
    );
};
